import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  equalsLowerCase1477z9rxwgcv2 as equalsLowerCase,
  hashCodeLowerCase2r6jfpu8gi2u9 as hashCodeLowerCase,
} from './internals/Chars.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SequenceScope1coiso86pqzq2 as SequenceScope,
  sequence2vgswtrxvqoa7 as sequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { DefaultPool2gb1fm4epwgu9 as DefaultPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/DefaultPool.mjs';
import { fill2542d4m9l93pn as fill } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { isIntArrayeijsubfngq38 as isIntArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_IntArrayPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return IntArrayPool;
}
var IntArrayPool;
function get_HeadersDataPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return HeadersDataPool;
}
var HeadersDataPool;
function thresholdReached($this) {
  return $this.m58_1 >= $this.n58_1 * 0.75;
}
function resize($this) {
  var prevSize = $this.m58_1;
  var prevData = $this.o58_1;
  $this.m58_1 = 0;
  $this.n58_1 = imul($this.n58_1, 2) | 128;
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = get_HeadersDataPool().v4m();
  this_0.r58(imul(prevData.q58(), 2) | 1);
  tmp.o58_1 = this_0;
  var _iterator__ex2g4s = prevData.s58().p1();
  while (_iterator__ex2g4s.q1()) {
    var headerOffset = _iterator__ex2g4s.r1();
    $this.u58(prevData.t58(headerOffset + 1 | 0), prevData.t58(headerOffset + 2 | 0), prevData.t58(headerOffset + 3 | 0), prevData.t58(headerOffset + 4 | 0));
  }
  get_HeadersDataPool().w4m(prevData);
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(prevSize === $this.m58_1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().n2(toString(message));
  }
}
function headerHasName($this, name, headerOffset) {
  var nameStartIndex = $this.o58_1.t58(headerOffset + 1 | 0);
  var nameEndIndex = $this.o58_1.t58(headerOffset + 2 | 0);
  return equalsLowerCase($this.l58_1, nameStartIndex, nameEndIndex, name);
}
var HttpHeadersMapClass;
function HttpHeadersMap() {
  if (HttpHeadersMapClass === VOID) {
    class $ {
      constructor(builder) {
        this.l58_1 = builder;
        this.m58_1 = 0;
        this.n58_1 = 0;
        this.o58_1 = get_HeadersDataPool().v4m();
      }
      u2o(name) {
        if (this.m58_1 === 0)
          return null;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(name);
        var hash = abs(this_0);
        var headerIndex = hash % this.n58_1 | 0;
        while (!(this.o58_1.t58(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            return this.v58(imul(headerIndex, 6));
          }
          headerIndex = (headerIndex + 1 | 0) % this.n58_1 | 0;
        }
        return null;
      }
      w58() {
        return this.o58_1.s58();
      }
      u58(nameStartIndex, nameEndIndex, valueStartIndex, valueEndIndex) {
        if (thresholdReached(this)) {
          resize(this);
        }
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(this.l58_1, nameStartIndex, nameEndIndex);
        var hash = abs(this_0);
        var name = this.l58_1.c(nameStartIndex, nameEndIndex);
        var headerIndex = hash % this.n58_1 | 0;
        var sameNameHeaderIndex = -1;
        while (!(this.o58_1.t58(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            sameNameHeaderIndex = headerIndex;
          }
          headerIndex = (headerIndex + 1 | 0) % this.n58_1 | 0;
        }
        var headerOffset = imul(headerIndex, 6);
        this.o58_1.e59(headerOffset + 0 | 0, hash);
        this.o58_1.e59(headerOffset + 1 | 0, nameStartIndex);
        this.o58_1.e59(headerOffset + 2 | 0, nameEndIndex);
        this.o58_1.e59(headerOffset + 3 | 0, valueStartIndex);
        this.o58_1.e59(headerOffset + 4 | 0, valueEndIndex);
        this.o58_1.e59(headerOffset + 5 | 0, -1);
        if (!(sameNameHeaderIndex === -1)) {
          this.o58_1.e59(imul(sameNameHeaderIndex, 6) + 5 | 0, headerIndex);
        }
        this.m58_1 = this.m58_1 + 1 | 0;
      }
      f59(headerOffset) {
        var nameStartIndex = this.o58_1.t58(headerOffset + 1 | 0);
        var nameEndIndex = this.o58_1.t58(headerOffset + 2 | 0);
        return this.l58_1.c(nameStartIndex, nameEndIndex);
      }
      v58(headerOffset) {
        var valueStartIndex = this.o58_1.t58(headerOffset + 3 | 0);
        var valueEndIndex = this.o58_1.t58(headerOffset + 4 | 0);
        return this.l58_1.c(valueStartIndex, valueEndIndex);
      }
      o2m() {
        this.m58_1 = 0;
        this.n58_1 = 0;
        get_HeadersDataPool().w4m(this.o58_1);
        this.o58_1 = get_HeadersDataPool().v4m();
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        dumpTo(this, '', this_0);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HttpHeadersMap');
    HttpHeadersMapClass = $;
  }
  return HttpHeadersMapClass;
}
var HeadersData$headersStarts$slambdaClass;
function HeadersData$headersStarts$slambda() {
  if (HeadersData$headersStarts$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.g59_1 = this$0;
      }
      *h59($this$sequence, $completion) {
        var joinedIndex = 0;
        var _iterator__ex2g4s = this.g59_1.p58_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var arr = _iterator__ex2g4s.r1();
          var localIndex = 0;
          while (localIndex < arr.length) {
            if (!(this.g59_1.t58(joinedIndex + 0 | 0) === -1)) {
              yield* $this$sequence.yk(joinedIndex, $completion);
            }
            localIndex = localIndex + 6 | 0;
            joinedIndex = joinedIndex + 6 | 0;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.h59(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HeadersData$headersStarts$slambdaClass = $;
  }
  return HeadersData$headersStarts$slambdaClass;
}
function HeadersData$headersStarts$slambda_0(this$0) {
  var i = new (HeadersData$headersStarts$slambda())(this$0);
  var l = ($this$sequence, $completion) => i.h59($this$sequence, $completion);
  l.$arity = 1;
  return l;
}
var HeadersDataClass;
function HeadersData() {
  if (HeadersDataClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.p58_1 = ArrayList().p2();
      }
      q58() {
        return this.p58_1.q2();
      }
      r58(subArraysCount) {
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < subArraysCount)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.p58_1.i2(get_IntArrayPool().v4m());
          }
           while (inductionVariable < subArraysCount);
      }
      t58(index) {
        return this.p58_1.r2(index / 768 | 0)[index % 768 | 0];
      }
      e59(index, value) {
        this.p58_1.r2(index / 768 | 0)[index % 768 | 0] = value;
      }
      s58() {
        return sequence(HeadersData$headersStarts$slambda_0(this));
      }
      o2m() {
        var _iterator__ex2g4s = this.p58_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var array = _iterator__ex2g4s.r1();
          get_IntArrayPool().w4m(array);
        }
        this.p58_1.a5();
      }
    }
    initMetadataForClass($, 'HeadersData', HeadersData);
    HeadersDataClass = $;
  }
  return HeadersDataClass;
}
function dumpTo(_this__u8e3s4, indent, out) {
  _init_properties_HttpHeadersMap_kt__hwatby();
  var _iterator__ex2g4s = _this__u8e3s4.w58().p1();
  while (_iterator__ex2g4s.q1()) {
    var offset = _iterator__ex2g4s.r1();
    out.o2(indent);
    out.o2(_this__u8e3s4.f59(offset));
    out.o2(' => ');
    out.o2(_this__u8e3s4.v58(offset));
    out.o2('\n');
  }
}
var IntArrayPool$1Class;
function IntArrayPool$1() {
  if (IntArrayPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      o4m() {
        var tmp = 0;
        var tmp_0 = new Int32Array(768);
        while (tmp < 768) {
          tmp_0[tmp] = -1;
          tmp = tmp + 1 | 0;
        }
        return tmp_0;
      }
      l59(instance) {
        fill(instance, -1);
        return protoOf(DefaultPool()).t4m.call(this, instance);
      }
      t4m(instance) {
        return this.l59(isIntArray(instance) ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    IntArrayPool$1Class = $;
  }
  return IntArrayPool$1Class;
}
var HeadersDataPool$1Class;
function HeadersDataPool$1() {
  if (HeadersDataPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      o4m() {
        return new (HeadersData())();
      }
      p59(instance) {
        instance.o2m();
        return protoOf(DefaultPool()).t4m.call(this, instance);
      }
      t4m(instance) {
        return this.p59(instance instanceof HeadersData() ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    HeadersDataPool$1Class = $;
  }
  return HeadersDataPool$1Class;
}
var properties_initialized_HttpHeadersMap_kt_kotj4w;
function _init_properties_HttpHeadersMap_kt__hwatby() {
  if (!properties_initialized_HttpHeadersMap_kt_kotj4w) {
    properties_initialized_HttpHeadersMap_kt_kotj4w = true;
    IntArrayPool = new (IntArrayPool$1())();
    HeadersDataPool = new (HeadersDataPool$1())();
  }
}
//region block: exports
export {
  HttpHeadersMap as HttpHeadersMapp7szignu4ex,
};
//endregion

//# sourceMappingURL=HttpHeadersMap.mjs.map
